export default class ConversationController {

  constructor($scope, $rootScope, $state, $stateParams, XucChat) {
    $scope.remoteParty = $stateParams.remoteParty;
    $scope.remotePartyHint = "4";
    $scope.dndStatus = false;

    $scope.getStatusClass = () => {
      if ($scope.dndStatus && $scope.remotePartyHint != "4")
        return `user-status-dnd`;
      return `user-status${$scope.remotePartyHint}`;
    };

    $rootScope.$on(XucChat.CURRENT_CHAT_LINESTATUS, (event, data) => {
      $scope.remotePartyHint = data;
    });

    $rootScope.$on(XucChat.CURRENT_CHAT_DNDSTATUS, (event, data) => {
      $scope.dndStatus = data;
    });

    $scope.gotoConversationHistory = () => {
      $state.go("interface.conversationHistory");
    };
  }
}
